var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.activIndex&&_vm.isShowNav()?'activ':'',attrs:{"id":"app"}},[(_vm.isShowNav()&&_vm.activIndex)?_c('head-title'):_vm._e(),_c('router-view'),(_vm.isShowNav()&&_vm.activIndex)?_c('navBars'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }